// extracted by mini-css-extract-plugin
export default {"formSelect":"Select_formSelect__DLjX7","inputGroup":"Select_inputGroup__9eJNA"};